/* eslint-disable import/no-anonymous-default-export */
export default (locationReceipt = [], action) => {
  switch (action.type) {
    case "LOCATION_RECEIPT":
      return action.payload;

    default:
      return locationReceipt;
  }
};
